export default __webpack_public_path__ + "static/media/effect-1.6a2a69ea.png";